export const buildParams = (values, page, entriesPerPage) => {
    const params = page !== undefined
        ? {
            offset: entriesPerPage * (page - 1),
            limit: entriesPerPage,
        }
        : {};
    const stringKeys = ['text', 'term_age'];
    const arrayKeys = ['term_workplace_category_id', 'term_institution_id', 'term_work_category_id', 'term_land_id', 'term_accommodation'];

    stringKeys.forEach(key => {
        if (values[key]) {
            params[key] = values[key];
        }
    });
    // if one of the parameter is set, no_restriction always matches
    if (params.term_age && params.term_age.length > 0) {
        params.term_age.push('no_restriction');
    }
    if (values.lat && values.lon) {
        params.geo_location_lat = values.lat;
        params.geo_location_lon = values.lon;
        params.geo_location_radius = values.radius;
    }
    arrayKeys.forEach(key => {
        if (values[key]) {
            params[key] = values[key].join(',');
        }
    });
    if (!params.text) {
        params.sorted_by = 'title';
    }
    return new URLSearchParams(params).toString();
};
